<template>
  <div class="app-wrapper" :style="appWrapperStyle">
    <AppDesktopHeader class="app-desktop-header" />
    <QLayout view="hHh Lpr fFf" class="app-layout-desktop prevent-overflow-x" container>
      <slot />
    </QLayout>
  </div>
</template>

<script>
import { ScrollManager } from "@core/managers/scroll.manager";
import { AnalyticsConsentManager } from "@core/managers/analytics-consent.manager";
import { EXTRACADABRA_DOMAIN, CORE_EVENTS, RECRUITMENT_COOKIE_NAME, RECRUITMENT_COOKIE_VALUE } from "@core/constants";
import { EventManager } from "@core/managers/event.manager";
import AppDesktopHeader from "./AppDesktop.header.vue";

export default {
  components: {
    AppDesktopHeader,
  },
  computed: {
    appWrapperStyle() {
      return {
        height: `${this.$q.screen.height}px`,
      };
    },
  },
  created() {
    EventManager.on(CORE_EVENTS.ON_LOGIN, this.onLoginDesktopActions);
    EventManager.on(CORE_EVENTS.ON_LOGOUT, this.onLogoutDesktopActions);
  },
  beforeUnmount() {
    EventManager.off(CORE_EVENTS.ON_LOGIN, this.onLoginDesktopActions);
    EventManager.off(CORE_EVENTS.ON_LOGOUT, this.onLogoutDesktopActions);
  },
  mounted() {
    this.manageScrollHelpers();
  },
  methods: {
    manageScrollHelpers() {
      const layoutContainerOffsetDesktop = 230; // height of header and container offset
      ScrollManager.configureScrollOffset(layoutContainerOffsetDesktop);

      // the scroll container is Quasar internal scroll div for containerized layout
      const scrollContainer = document.getElementsByClassName("scroll")[0];
      ScrollManager.configureScrollContainer(scrollContainer);
    },
    onLoginDesktopActions() {
      // does the user consented to store cookies?
      const userConsented = AnalyticsConsentManager.getStoredConsent();
      if (userConsented) {
        // tell the other extracadabra websites that the user is logged
        this.$q.cookies.set(RECRUITMENT_COOKIE_NAME, RECRUITMENT_COOKIE_VALUE, {
          domain: EXTRACADABRA_DOMAIN,
          expires: 1000,
        });
      }
    },
    onLogoutDesktopActions() {
      this.$q.cookies.remove(RECRUITMENT_COOKIE_NAME, {
        domain: EXTRACADABRA_DOMAIN,
        expires: 1000,
      });
    },
  },
};
</script>

<style lang="scss">
.app-wrapper {
  $app-header-height: 50px;

  width: 100%;
  height: 100%;
  position: relative;
  background: $grey-4;

  .prevent-overflow-x {
    .scroll {
      overflow-x: hidden; //quasar override to prevent horizontal scrollbar during animation
    }
  }

  &:before {
    content: "";
    height: $app-header-height;
    position: fixed;
    top: 0;
    width: 100%;
    background: $secondary;
  }

  .app-layout-desktop,
  .app-desktop-header {
    margin: 0 auto;
    z-index: 4000;
    width: 100%;
    max-width: $breakpoint-md;
  }

  .app-layout-desktop {
    background: #f5f5f5;
    height: calc(100% - #{$app-header-height});
  }
  .app-desktop-header {
    height: $app-header-height;
    border-radius: 0;

    .q-btn {
      margin: 0 5px;
    }
  }

  @media (max-width: $breakpoint-sm) {
    padding: 0;

    .app-layout-desktop,
    .app-desktop-header {
      width: 100%;
      max-width: 100%;
      border-radius: 0;
    }
  }

  @media (max-width: $breakpoint-xs) {
    .app-layout-desktop {
      height: 100%;
    }
  }
}
</style>
